import type { PlayerGameRequestResult } from "@uno/protocol";

export default function getPlayerGamePath(
    result: PlayerGameRequestResult,
): string {
    return result.destination === "room"
        ? `/room/${result.roomId}`
        : `/lobby/${result.id}`;
}
